module.exports = __webpack_public_path__ + "img/sqlServer.3084f543.jpg";